var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77652 0.552786C5.91728 0.482405 6.08296 0.482405 6.22373 0.552786L11.2237 3.05279C11.3931 3.13748 11.5001 3.31061 11.5001 3.5C11.5001 3.68939 11.3931 3.86252 11.2237 3.94721L6.22373 6.44721C6.08296 6.5176 5.91728 6.5176 5.77652 6.44721L0.776515 3.94721C0.607123 3.86252 0.500122 3.68939 0.500122 3.5C0.500122 3.31061 0.607123 3.13748 0.776515 3.05279L5.77652 0.552786ZM2.11816 3.5L6.00012 5.44098L9.88209 3.5L6.00012 1.55902L2.11816 3.5Z",
    fill: "#787A84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.552896 8.27638C0.676391 8.02939 0.976727 7.92928 1.22372 8.05277L6.00011 10.441L10.7765 8.05277C11.0235 7.92928 11.3238 8.02939 11.4473 8.27638C11.5708 8.52337 11.4707 8.82371 11.2237 8.9472L6.22372 11.4472C6.08295 11.5176 5.91727 11.5176 5.7765 11.4472L0.776503 8.9472C0.529513 8.82371 0.429401 8.52337 0.552896 8.27638Z",
    fill: "#787A84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.552896 5.77638C0.676391 5.52939 0.976727 5.42928 1.22372 5.55277L6.00011 7.94097L10.7765 5.55277C11.0235 5.42928 11.3238 5.52939 11.4473 5.77638C11.5708 6.02337 11.4707 6.32371 11.2237 6.4472L6.22372 8.9472C6.08295 9.01758 5.91727 9.01758 5.7765 8.9472L0.776503 6.4472C0.529513 6.32371 0.429401 6.02337 0.552896 5.77638Z",
    fill: "#787A84"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdks);
export default __webpack_public_path__ + "static/media/sdks.090bb610.svg";
export { ForwardRef as ReactComponent };